import React, {createRef} from 'react';
import arrow from '../Resources/icons/diagonal-arrow.svg';
import './SlideItem.css';
import PropTypes from 'prop-types';
import {getSpan} from "../Utilities/utils";
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';

function SlideItem(props) {

    let background

    if (props.bgImage) {
        background = <div className={"slide-bg"}>
            {props.id == 'p-insight-item' ?
                <div style={{
                    margin: '0 auto',
                    overflow: 'hidden',
                    position: 'relative',
                    height: '100%'
                }}>
                    <img style={{
                        left: '50%',
                        marginLeft: '-400px',
                        width: 'auto',
                        position: 'absolute'
                    }} className={"slide-bg accessibility-img"}
                         src={props.bgImage} alt={'slide'}/>
                </div> :
                <img className={"slide-bg accessibility-img"}
                     src={props.bgImage} alt={'slide'}/>
            }
        </div>
    }

    function getFormatSlideItem() {
        return <div
            id={props.id}
            className={props.className}
            onClick={props.clickEvent}
        >
            {background}
            <div ref={props.contentRef}
                 className={"slide-content"}>
                <div id={props.id + '-top'}
                     className={'slide-top'}>
                    {props.children}
                </div>
                <div id={props.id + '-title'}
                     className={"slide-title " + props.fontTitle}
                     style={{color: props.titleColor}}>
                    {getSpan(props.title)}
                </div>
                <div id={props.id + '-subtitle'}
                     className={"accessibility-font " + props.fontSubtitle}>
                    {getSpan(props.subTitle)}

                </div>
                <ArrowForwardRoundedIcon style={{color: "black", width: "20px"}}/>
                <div id={props.id + '-metrics'}
                    /*className={"slide-subtitle accessibility-font " + props.fontSubtitle}*/>
                    {getSpan(props.metrics)}
                </div>
                <div className={'slide-content' + (props.clickable ? " clickable" : "not-clickable")}
                     style={{position: 'absolute'}}/>
            </div>
            <div ref={props.msgRef} className={'slide-msg'}>
            </div>
        </div>;
    }

    function isPScene9(id: string): boolean {
        return id === "p-showcase-item" || id === "p-insight-item" || id === "p-360-item" || id === "p-blog-item"
    }

    function isScene10(id: string): boolean {
        return id === "showcase-item" || id === "insight-item" || id === "360-item" || id === "blog-item" || id === "whitePaper-item"
    }

    function getSlideItem() {
        return <div
            id={props.id}
            className={props.className}
            onClick={props.clickEvent}
        >
            {background}
            <div ref={props.contentRef}
                 className={"slide-content"}>
                <div id={props.id + '-top'}
                     className={'slide-top'}>
                    {props.children}
                </div>
                <div id={props.id + '-title'}
                     className={"slide-title " + props.fontTitle}
                     style={{color: props.titleColor}}>
                    {getSpan(props.title)}
                </div>
                <div id={props.id + '-subtitle'}
                     className={"slide-subtitle accessibility-font " + props.fontSubtitle}>
                    {getSpan(props.subTitle)}
                </div>
                {isPScene9(props.id) && <ArrowForwardRoundedIcon className={"arrow-forward-carrousel"}/>}
                {isScene10(props.id) && props.footer}
                <div className={'slide-content' + (props.clickable ? " clickable" : "not-clickable")}
                     style={{position: 'absolute'}}/>
            </div>
            <div ref={props.msgRef} className={'slide-msg'}>
            </div>
        </div>;
    }

    return (
        props.title[0].includes('format') ?
            getFormatSlideItem() :
            getSlideItem()
    );
}

SlideItem.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.arrayOf(PropTypes.string).isRequired,
    titleColor: PropTypes.string,
    fontTitle: PropTypes.string,
    subTitle: PropTypes.arrayOf(PropTypes.string).isRequired,
    fontSubtitle: PropTypes.string,
    children: PropTypes.element,
    footer: PropTypes.element,
    clickEvent: PropTypes.func,
    bgImage: PropTypes.any,
    className: PropTypes.string,
    clickable: PropTypes.bool,
    contentRef: PropTypes.object,
    msgRef: PropTypes.object,
}

SlideItem.defaultProps = {
    className: 'slide-item',
    children: <div className={"default-top"}/>,
    footer: <div className={"slide-bottom"}>
        <img className={"bottom-arrow"} src={arrow} alt="arrow"/>
    </div>,
    titleColor: '#fff',
    fontTitle: 'font-title',
    fontSubtitle: 'font-subtitle',
    contentRef: createRef(),
    msgRef: createRef(),
    clickable: false,
    clickEvent: () => {
    }
}

export default SlideItem;
